module.exports = __webpack_public_path__ + "images/emoji/kissing.d4830f6fbe6cf11bc710.png";